<template>
  <f7-page>
    <navbar :text="$t('')" />
    <DxViewClient />
    <f7-block>
      <f7-row>
        <f7-col>
          <f7-button
            class="dx-btn-cancel padding-horizontal"
            raised
            type="default"
            text-color="grey"
            styling-mode="outlined"
            name="ButtonCancel"
            @click="goToBack()"
          >
            {{ $t("Button_go_to_back") }}
          </f7-button>
        </f7-col>
        <f7-col>
          <f7-button
            class="dx-btn-success"
            raised
            type="success"
            styling-mode="contained"
            @click="goToSystemParcel"
          >
            {{ $t("Button_go_to_parcel_system") }}
          </f7-button>
        </f7-col>
      </f7-row>
    </f7-block>
  </f7-page>
</template>

<script>
import { mapActions } from 'vuex';
import DxViewClient from '../../../components/utilities/clients/DxViewClient.vue';
import navbar from '../../../components/NavBar.vue';

export default {
  name: 'ViewClient',
  components: {
    DxViewClient,
    navbar,
  },
  props: {
    pathBack: { type: String, default: 'clients' },
  },
  methods: {
    goToBack() {
      this.$f7.views.main.router.navigate(`/${this.pathBack}/`, {
        reloadCurrent: true,
      });
    },
    goToSystemParcel() {
      this.setActualMenuSelected('/systemParcelViewClientsPage/');
      this.$f7.views.main.router.navigate('/systemParcelViewClientsPage/', {
        reloadCurrent: true,
      });
    },
    ...mapActions('authentication', ['setActualMenuSelected']),
  },
};
</script>
<style scoped>

</style>
